'use client';

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { LayoutCluster } from 'design-system/client';
import type { StaticImageData } from 'next/image';
import { useTranslations } from 'next-intl';
import type { CSSProperties } from 'react';
import { widgetStyleConfig } from '../predefinedStylesConfig';
import styles from './StyledAllInclusiveAlert.module.css';
import TrustedHtml from '@/components/TrustedHtml';
import useGoogleFonts from '@/fonts/useGoogleFonts';
function StyledAllInclusiveAlert(t0) {
  const $ = _c(57);
  const {
    totalDonationAmount,
    lastDonationAmount,
    lastDonationDonor,
    topDonationAmount,
    topDonationDonor,
    kind
  } = t0;
  const t = useTranslations("nextjs.streambot");
  const {
    leftDecorator,
    rightDecorator,
    background,
    fontFamily,
    fontWeights
  } = widgetStyleConfig[kind];
  let t1;
  if ($[0] !== fontFamily || $[1] !== fontWeights) {
    t1 = {
      fonts: [{
        family: fontFamily,
        weights: fontWeights
      }]
    };
    $[0] = fontFamily;
    $[1] = fontWeights;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useGoogleFonts(t1);
  const t2 = styles[kind];
  let t3;
  if ($[3] !== t2) {
    t3 = classNames(styles.container, t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `url(${(leftDecorator as unknown as StaticImageData).src})`;
  const t5 = `url(${(rightDecorator as unknown as StaticImageData).src})`;
  const t6 = `"${fontFamily}"`;
  let t7;
  if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
    t7 = {
      "--left-decorator": t4,
      "--right-decorator": t5,
      "--font-family": t6
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = t7 as CSSProperties;
  const t9 = `url(${(background as unknown as StaticImageData).src})`;
  let t10;
  if ($[9] !== t9) {
    t10 = {
      "--center-background": t9
    };
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = t10 as CSSProperties;
  let t12;
  if ($[11] !== t) {
    t12 = t("total_headline");
    $[11] = t;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t12) {
    t13 = <p className={styles.heading}>{t12}</p>;
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== totalDonationAmount) {
    t14 = <div className={styles.donationsTotal}><div>{totalDonationAmount}</div></div>;
    $[15] = totalDonationAmount;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== t13 || $[18] !== t14) {
    t15 = <div id="standard-left" className={styles.left}>{t13}{t14}</div>;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t) {
    t16 = t("standard.last_donation");
    $[20] = t;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t16) {
    t17 = <p className={styles.heading}>{t16}</p>;
    $[22] = t16;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== lastDonationDonor) {
    t18 = <TrustedHtml value={lastDonationDonor} />;
    $[24] = lastDonationDonor;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== lastDonationAmount) {
    t19 = <div>{lastDonationAmount}</div>;
    $[26] = lastDonationAmount;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t18 || $[29] !== t19) {
    t20 = <div className={styles.dataContainer}>{t18}{t19}</div>;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== t17 || $[32] !== t20) {
    t21 = <div id="standard-center" className={styles.center}>{t17}{t20}</div>;
    $[31] = t17;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== t) {
    t22 = t("standard.top_donation");
    $[34] = t;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== t22) {
    t23 = <p className={styles.heading}>{t22}</p>;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== topDonationDonor) {
    t24 = <TrustedHtml value={topDonationDonor} />;
    $[38] = topDonationDonor;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== topDonationAmount) {
    t25 = <div>{topDonationAmount}</div>;
    $[40] = topDonationAmount;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t24 || $[43] !== t25) {
    t26 = <div className={styles.dataContainer}>{t24}{t25}</div>;
    $[42] = t24;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== t23 || $[46] !== t26) {
    t27 = <div id="standard-right" className={styles.right}>{t23}{t26}</div>;
    $[45] = t23;
    $[46] = t26;
    $[47] = t27;
  } else {
    t27 = $[47];
  }
  let t28;
  if ($[48] !== t11 || $[49] !== t15 || $[50] !== t21 || $[51] !== t27) {
    t28 = <div className={styles.innerContainer} style={t11}>{t15}{t21}{t27}</div>;
    $[48] = t11;
    $[49] = t15;
    $[50] = t21;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t28 || $[54] !== t3 || $[55] !== t8) {
    t29 = <LayoutCluster className={t3} style={t8}>{t28}</LayoutCluster>;
    $[53] = t28;
    $[54] = t3;
    $[55] = t8;
    $[56] = t29;
  } else {
    t29 = $[56];
  }
  return t29;
}
export default StyledAllInclusiveAlert;